// ─── La columna «Textos clave» del cronograma de un módulo en el PDF (S2) ────
// Antes salía siempre, con «—» en cada fila de un módulo sin citas. Ahora sale
// solo si al menos una sesión DEL MÓDULO tiene textos clave; cada módulo decide
// por su cuenta.

export function showKeyTextsColumn(sessions: readonly { scriptureRefs?: string }[]): boolean {
  return sessions.some((s) => !!s.scriptureRefs?.trim());
}
